module.exports = __webpack_public_path__ + "static/fonts/jura-latin-ext.5e4e9f5.woff2";